import { render } from "./EditProductPriceList.vue?vue&type=template&id=38418553&scoped=true"
import script from "./EditProductPriceList.vue?vue&type=script&lang=js"
export * from "./EditProductPriceList.vue?vue&type=script&lang=js"

import "./EditProductPriceList.vue?vue&type=style&index=0&id=38418553&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38418553"]])

export default __exports__